import { destroyerQuotes } from "./destroyer";
import { effarigQuotes } from "./effarig";
import { enslavedQuotes } from "./enslaved";
import { laitelaQuotes } from "./laitela";
import { pelleQuotes } from "./pelle";
import { raQuotes } from "./ra";
import { teresaQuotes } from "./teresa";
import { vQuotes } from "./v";
import { kohlerQuotes } from "./kohler";

export const quotes = {
  teresa: teresaQuotes,
  effarig: effarigQuotes,
  enslaved: enslavedQuotes,
  v: vQuotes,
  ra: raQuotes,
  laitela: laitelaQuotes,
  pelle: pelleQuotes,
  destroyer: destroyerQuotes,
  kohler: kohlerQuotes,
};
